<!-- PART EXCHANGE VALUATION  -->

<div *ngIf="valuation" class="valuation modal-row">
	<h2 class="valuation-heading">Your valuation estimate:</h2>

	<!--  VALUATION DISPLAY  -->

	<div class="value sec-fg pos-bg">
		<span *ngIf="valuation.min_value !== null && valuation.max_value !== null" class="min">
			{{ valuation.min_value | money: 2 }}
		</span>
		<span *ngIf="valuation.min_value !== null && valuation.max_value !== null" class="to">-</span>
		<span class="max">
			{{
				(valuation.min_value !== null && valuation.max_value !== null
					? valuation.max_value
					: valuation.allowance
				) | money: 2
			}}
			<span *ngIf="valuation.min_value !== null && valuation.max_value !== null">*</span>
		</span>
	</div>

	<!--  END VALUATION DISPLAY  -->

	<!--  DISCLAIMER  -->

	<div *ngIf="valuation.min_value">
		<p class="ranged-disclaimer">
			* We will use the value of
			<strong>{{ valuation.allowance | money: 2 }}</strong>
			in any further calculations.
		</p>
	</div>

	<h2 class="part-ex-heading">Your Part Ex Vehicle</h2>

	<cng-vehicle-title
		[vehicle]="vehicle_info"
		[view]="'valuation_modal'"
		[show_registration]="vehicle_info.registration !== null"
	></cng-vehicle-title>

	<p>
		Any part exchange valuations obtained on this site are estimates based on the information you have submitted.
		We'll need to appraise your vehicle upon seeing the part exchange, if you have any questions you can arrange a
		callback below to speak to one of our team. For full details please see our Terms of Use.
	</p>

	<div class="powered-by-cap-container">
		<h3>Powered by:</h3>
		<img src="assets/img/cap.png" alt="Cap" />
	</div>

	<!--  END DISCLAIMER  -->
</div>

<div class="second-opinion-container modal-row">
	<h2>Want a second opinion?</h2>
	<img src="assets/img/auto_trader.png" alt="AutoTrader" />
	<p>
		If you're not happy with your part exchange valuation or want a
		<br />
		second opinion, take a look at the part exchange service from
		<br />
		AutoTrader.
	</p>
</div>

<!-- END PART EXCHANGE VALUATION  -->
